import React from 'react';
import LoginForm from '../components/auth/LoginForm';

function LoginPage() {
  return (
    <div className="page">
      <LoginForm />
    </div>
  );
}

export default LoginPage;